import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
  position: relative;
`;

const shared = css`
  width: 100%;
  height: ${(p) => (p.isAuto && 'auto') || (p.isModal && '87px') || '160px'};
`;

export const StyledHolder = styled.div`
  ${shared};

  background-color: ${(p) => p.theme.alias.shadow};
`;

export const StyledBanner = styled.img`
  ${shared};

  display: block;
  object-fit: cover;
`;

export const StyledShadow = styled.div`
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  border-left: 2px solid ${(p) => p.theme.alias.bg};
  border-right: 2px solid ${(p) => p.theme.alias.bg};
  border-bottom: 2px solid ${(p) => p.theme.alias.bg};
`;
